export default class DtoQualityProducer {
    constructor(obj = {}) {
        this.contributorCode = obj.contributorCode
        this.name = obj.name
        this.siret = obj.siret
    }
}